<template>
  <div>
    <Modal class="modal" v-model="showModal" width="80%" :styles="queryConfig.popStyle" title="审批流程" @on-visible-change="ondestroy">
      <!-- 审批流程图 -->
      <div v-if='!showuser' :class='"audit-log " + (istask && auditLog.length>0 ? "bd-space" : "")' :style='{height: currentHeight-165+"px"}'>
        <!-- 审批流各节点 -->
        <div v-for="(item,index) in auditLog">
          <div :class='"wx-row" + (item.act_status_ != "M" && item.act_status_ != "A" ? " color-gray" : "")'>
            <!-- 节点头部 -->
            <div class='wx-col' @click='showGroupUser(index)'>
              <div class='user'>
                <div class='username'>
                  <div v-if='item.tasklist && item.tasklist.length == 1'>{{item.tasklist[0].userName}}</div>
                  <div v-if='item.tasklist && item.tasklist.length !== 1' class='iconfont icon-team'>
                    <Icon type="md-people" />
                  </div>
                  <div class='icon' v-if="item.act_status_">
                    <div :class='"iconfont " + formatIcon(item.act_status_)'>
                      <Icon v-if='formatIcon(item.act_status_) == "icon-success"' type="md-checkmark-circle" />
                      <Icon v-else-if='formatIcon(item.act_status_) == "icon-close"' type="md-close-circle" />
                      <Icon v-else-if='formatIcon(item.act_status_) == "icon-more"' type="ios-time" />
                    </div>
                  </div>
                </div>
                <div class='step-text'>
                  <div class='title'>{{item.act_name_}}</div>
                  <div class='main'>{{item.describe_}}</div>
                </div>           
              </div>
              <div class='time'>
                <div class='time' v-if='item.act_status_ != "M"'>{{item.act_time_}}</div>
                <div class='time'>
                  <div :class='"iconfont " + "iconarrow"'>
                    <Icon v-if='item.active' type="ios-arrow-up" />
                    <Icon v-else type="ios-arrow-down" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 节点人组 -->
            <div :class='"team " + (item.act_status_ == "M" ? "full" : "") + (index == auditLog.length-1 && copyuser.length == 0 ? " no-bd" : "")' v-if='item.active || copyuser.length > 0 || index != auditLog.length-1 || item.act_status_ == "M"'>
              <div class='user-list' v-if='item.active && item.tasklist && item.tasklist.length > 0'>
                <div v-for='(list,idx) in item.tasklist'>
                  <div class='user-list-wrap'>
                    <div class='user-item'>
                      <div>{{list.userName}}</div>
                      <div class='icon' v-if="list.status">
                        <div :class='"iconfont " + formatIcon(list.status)'>
                          <Icon v-if="formatIcon(list.status) == 'icon-success'" type="md-checkmark-circle" />
                          <Icon v-else-if="formatIcon(list.status) == 'icon-close'" type="md-close-circle" />
                          <Icon v-else-if="formatIcon(list.status) == 'icon-more'" type="ios-time" />
                        </div>
                      </div>
                    </div> 
                    <div class="info">
                      <div class='name'>{{list.username}}</div>
                      <div class='comment' v-if="list.message">处理意见：{{list.message}}</div> 
                    </div>
                  </div>
                </div>
              </div>
              <div v-if='!item.active && item.act_status_ != "M" && item.tasklist && item.tasklist.length == 1 && item.tasklist[0] && item.tasklist[0].message' class="comment">
                处理意见：{{item.tasklist[0].message}}
              </div>
            </div>
          </div>

          <!-- 添加节点 -->
          <div class='wx-row' v-if='auditLog[index-1] && auditLog[index-1].act_status_ == "Y" && auditLog[index] && auditLog[index].act_status_ == "M" && auditLog[index].isMulti != "Y"  && istask'>
            <div class='wx-col add-el'>
              <div class='add-wrap' @click='openUser'>
                <div class='add-btn'>
                  <div class='iconfont icon-add'>
                    <Icon type="ios-add" />
                  </div>
                </div>
                <div>添加节点</div>
              </div>
            </div>
            <div :class='"team " + (item.act_status_ !== "Y" ? "full" : "")'></div>
          </div>
        </div>

        <!-- 抄送人 -->
        <div class='wx-row' v-if='copyuser.length > 0'>
          <div class='wx-col' @click="showCopyClick">
            <div class='user'>
              <div class='username'>
                <div class='iconfont icon-bell'>
                  <Icon type="ios-notifications" />
                </div>
              </div>
              <div class='step-text'>
                <div class='title'>抄送人</div>
                <div class='main'>抄送{{copyuser.length}}人</div>
              </div>
            </div>
            <div class='time'>
              <div class='"iconfont " + "iconarrow"'>
                <Icon v-if='showcopy' type="ios-arrow-up" />
                <Icon v-else type="ios-arrow-down" />
              </div>
            </div>
          </div>
          <div class='team no-bd'>
            <div class='user-list' v-if='showcopy'>
              <div class='user-list-wrap' v-for="(item) in copyuser">
                <div class='user-item'>
                    <div>{{item.name}}</div>
                </div> 
                <div class="info">{{item.copyuser}}</div>                 
              </div>
            </div>
          </div>
        </div>

        <div v-if="auditLog.length == 0" class="nodata">暂无审批流数据</div>
      </div>

      <!-- 选择审批人/抄送人 -->
      <div v-if='showuser'>
        <div class='top'>
          <Input search placeholder="搜索" v-model="searchKey" @on-change='change' @on-search='search'/>
          <Tabs @on-click='clickTab'>
            <TabPane v-for='(item) in tabList' :label='item.label' :name='item.name' ></TabPane>
          </Tabs>
        </div>
        <div class='content'>
          <div class='scroll-wrap'>
            <CheckboxGroup class="checkbox-group" name="user" v-model="select" :style='{height: currentHeight-233+"px"}'>
              <div class="checkbox" v-for='(item,index) in list'>
                <Checkbox :label='item.id' class="checkboxrow">
                  <div class='icon'>
                    <div v-if='selectType=="USER"'>{{item.name}}</div>
                    <div class='iconfont icon-team' v-if='selectType=="USERGROUP"'>
                      <Icon type="md-people" />
                    </div>
                  </div>
                  <div class='uname' v-if='selectType=="USER"'>{{item.firstName}}{{item.lastName}}</div>
                  <div class='uname' v-if='selectType=="USERGROUP"'>{{item.name}}</div>
                </Checkbox>
              </div>
            </CheckboxGroup>
          </div>  
        </div>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer">
        <!-- 选择审批人/抄送人 -->
        <div v-if='showuser' class='btn-area'>
          <Button @click="canceluser">取消</Button>
          <Button type="primary" @click="okuser">{{isSubmit ? '确定提交' : '确定'}}({{select.length}}/{{list.length}})</Button>
        </div>
        <!-- 审批日志 -->
        <div v-if='!showuser' class='btn-group'>
          <div v-if='istask && (value.billstatus == "S" || value.billstatus == "A")' class='btn-group'>
            <Button class='btn-item' @click='reject'>
              <div class='iconfont icon-reject'>
                <Icon type="ios-remove-circle-outline" />
              </div>
              <div>驳回</div>
            </Button>
            <Button type="primary" class='btn-item' @click='pass'>
              <div class='iconfont icon-pass'>
                <Icon type="ios-checkmark-circle-outline" />
              </div>
              <div>通过</div>
            </Button>
          </div>
          <Button v-else-if='isSub && (value.billstatus == "S" || (istask && value.billstatus == "R"))' class='btn-item' @click='billBack'>
            <div class='iconfont icon-backout'>
              <Icon type="ios-refresh-circle-outline" />
            </div>
            <div>撤回</div>
          </Button>
          <Button v-else @click="hideModal">关闭</Button>
        </div>
      </div>

      <!-- 处理意见弹框 -->
      <Modal v-model="showopinion" title="处理意见">
        <Input v-model="opinion" type="textarea" :rows="5" placeholder="请填写处理意见" />
        <div slot="footer" class='opinionfoot'>
          <Button @click="cancelOpinion">取消</Button>
          <Button type="primary" @click="okOpinion">确定</Button>
        </div>
      </Modal>
    </Modal>

    <!-- 显示审批流日志(无操作) -->
    <Card :padding="0" :headClass="headClass" :extraClass="extraClass">
      <p v-if="showTitle" slot="title" :style="pStyle" @click="toggle" >
        <span :class="titleClass" v-text="myConfig.title" /> <Icon v-if="myConfig.hide" :style="iconStyle" type='ios-arrow-forward'/> 
      </p>
      <div v-show="showGrid" :style="cardStyle" >
        <div v-if='showDiv' class='audit-log'>
          <!-- 审批流各节点 -->
          <div v-for="(item,index) in auditLog">
            <!-- 节点头部 -->
            <div :class='"wx-row" + (item.act_status_ != "M" && item.act_status_ != "A" ? " color-gray" : "")'>
              <div class='wx-col' @click='showGroupUser(index)'>
                <div class='user'>
                  <div class='username'>
                    <div v-if='item.tasklist && item.tasklist.length == 1'>{{item.tasklist[0].userName}}</div>
                    <div v-if='item.tasklist && item.tasklist.length !== 1' class='iconfont icon-team'>
                      <Icon type="md-people" />
                    </div>
                    <div class='icon' v-if="item.act_status_">
                      <div :class='"iconfont " + formatIcon(item.act_status_)'>
                        <Icon v-if='formatIcon(item.act_status_) == "icon-success"' type="md-checkmark-circle" />
                        <Icon v-else-if='formatIcon(item.act_status_) == "icon-close"' type="md-close-circle" />
                        <Icon v-else-if='formatIcon(item.act_status_) == "icon-more"' type="ios-time" />
                      </div>
                    </div>
                  </div>
                  <div class='step-text'>
                    <div class='title'>{{item.act_name_}}</div>
                    <div class='main'>{{item.describe_}}</div>
                  </div>           
                </div>
                <div class='time'>
                  <div class='time' v-if='item.act_status_ != "M"'>{{item.act_time_}}</div>
                  <div class='time'>
                    <div :class='"iconfont " + "iconarrow"'>
                      <Icon v-if='item.active' type="ios-arrow-up" />
                      <Icon v-else type="ios-arrow-down" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 节点人组 -->
              <div :class='"team " + (item.act_status_ == "M" ? "full" : "") + (index == auditLog.length-1 && copyuser.length == 0 ? " no-bd" : "")' v-if='item.active || copyuser.length > 0 || index != auditLog.length-1 || item.act_status_ == "M"'>
                <div class='user-list' v-if='item.active && item.tasklist && item.tasklist.length > 0'>
                  <div v-for='(list,idx) in item.tasklist'>
                    <div class='user-list-wrap'>
                      <div class='user-item'>
                        <div>{{list.userName}}</div>
                        <div class='icon' v-if="list.status">
                          <div :class='"iconfont " + formatIcon(list.status)'>
                            <Icon v-if="formatIcon(list.status) == 'icon-success'" type="md-checkmark-circle" />
                            <Icon v-else-if="formatIcon(list.status) == 'icon-close'" type="md-close-circle" />
                            <Icon v-else-if="formatIcon(list.status) == 'icon-more'" type="ios-time" />
                          </div>
                        </div>
                      </div> 
                      <div class="info">
                        <div class='name'>{{list.username}}</div>
                        <div class='comment' v-if="list.message">处理意见：{{list.message}}</div> 
                      </div>                
                    </div>
                  </div>
                </div>
                <div v-if='!item.active && item.act_status_ != "M" && item.tasklist && item.tasklist.length == 1 && item.tasklist[0] && item.tasklist[0].message' class="comment">
                  处理意见：{{item.tasklist[0].message}}
                </div>
              </div>
            </div>
          </div>

          <!-- 抄送人 -->
          <div class='wx-row' v-if='copyuser.length > 0'>
            <div class='wx-col' @click="showCopyClick">
              <div class='user'>
                <div class='username'>
                  <div class='iconfont icon-bell'>
                    <Icon type="ios-notifications" />
                  </div>
                </div>
                <div class='step-text'>
                  <div class='title'>抄送人</div>
                  <div class='main'>抄送{{copyuser.length}}人</div>
                </div>
              </div>
              <div class='time'>
                <div class='"iconfont " + "iconarrow"'>
                  <Icon v-if='showcopy' type="ios-arrow-up" />
                  <Icon v-else type="ios-arrow-down" />
                </div>
              </div>
            </div>
            <div class='team no-bd'>
              <div class='user-list' v-if='showcopy'>
                <div class='user-list-wrap' v-for="(item) in copyuser">
                  <div class='user-item'>
                      <div>{{item.name}}</div>
                  </div> 
                  <div class="info">{{item.copyuser}}</div>                 
                </div>
              </div>
            </div>
          </div>

          <div v-if="auditLog.length == 0" class="nodata">暂无审批流数据</div>
        </div>
      </div>
    </Card>
    <!-- 提交弹框 -->
    <Modal v-model="showSubmit" width="400" class="submitmodal">
      <div class="modalcontent"><Icon type="md-help-circle" class="helpicon"/>确定提交审批流？</div>
      <div slot="footer">
        <Button type="text" @click="selectCopy">选择抄送人</Button>
        <Button type="primary" @click="onSubmit">确定提交</Button>
      </div>
    </Modal>
  </div> 
</template>

<script>
import load from '@/components/base/load';
import size from '@/components/base/size';
export default {
    name: 'approvalbox',
    mixins: [load,size],
    data() {
        return {
            myConfig: {
                resources: '',
                classPrefix: '',

                hide:true,
                headStyle:'',
                titleType:1,
                title:'审批日志',
            },
            value: {
                billmoduleid: '',
                billno: '',
                billstatus: '',
            },
            queryConfig:{
                popStyle:{
                    top: '20px',
                    minHeight: '50%',
                    maxHeight: '100%'
                }
            },
            showModal: false,
            showDiv: false,
            showcopy: false,
            auditLog: [],
            copyuser: [],
            istask: false,
            isSub: false,
            showuser: false,
            showopinion: false,
            opinion: '',
            height: 0,

            isSubmit: false,
            searchKey: '',
            selectType: '',
            searchText: '',
            tabList: [
        { label: '审批人', name: 'USER', active: true },
        { label: '招商组', name: 'USERGROUP', active: false }
            ],
            list: [],
            userList: [],
            groupList: [],
            select: [],
            
            cardPadding:0,
            cardStyle:'',
            showGrid:true,
            showTitle:true,
            pStyle:'',
            iconStyle:'',
            bussinesscode:'',

            showSubmit: false,
        };
    },
    created() {
        this.myConfig = Object.assign({}, this.myConfig, this.config); 
        this.showDiv = true;
        this.showuser = false;

        this.myConfig.titleType = this.config.titleType;
        this.setSizeConfig(this.myConfig);
        this.customInit ();
    },
    computed: {
        titleClass () {
            return `efuture-title-font-${this.myConfig.titleType}`;
        },
        headClass () {
            if (!this.showGrid) {
                return `efuture-card-head-title-${this.myConfig.titleType}` + ' efuture-card-head-title-nobottom';
            } else {
                return `efuture-card-head-title-${this.myConfig.titleType}`;
            }
        },
        extraClass () {
            return `efuture-card-extra-title-${this.myConfig.titleType}`;
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
    },
    methods: {
        customInit() {
            if (this.myConfig.hide) {
                this.pStyle = 'cursor:pointer';
                this.iconStyle = 'transform: rotate(90deg)';
            } 
            this.cardPadding = 5 * Number(this.myConfig.titleType);
            this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px';
        },
        toggle () {
            if (this.myConfig.hide) {
                this.showGrid = !this.showGrid;
                this.setTitleStyle();
            }
        },
        setShowGrid(value) {
            this.showGrid = value;
            this.setTitleStyle();
        },
        setTitleStyle () {
            if (this.showGrid) {
                this.iconStyle = 'transform: rotate(90deg)';
                this.cardPadding =  5 * Number(this.myConfig.titleType);
                this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px';
            } else {
                this.iconStyle = '';
                this.cardPadding  = 0;
                this.cardStyle = '';
            }
        },
        submit() {
            this.showSubmit = true;
        },
        selectCopy() {
            this.isSubmit = true;
            this.showModal = true;
            this.openUser();
            this.showSubmit = false;
        },
        onSubmit() {
            this.billSubmit();
            this.showSubmit = false;
        },
        show() {
            this.isSubmit = false;
            this.showModal = true;
            this.showuser = false;
            this.getData();
        },
        setData(config) {
            this.value ={};
            Object.assign(this.value, config);
            this.getAuditLog();
        },
        clearData() {
            this.auditLog = [];
        },
        ondestroy(value) {
            if (!value) {
                if (this.myConfig.onDestroy) {
                    this.myConfig.onDestroy(this.myConfig);
                }
            }
        },
        getData() {
            this.getSubuser();
            this.getTaskID();
            this.getAuditLog();
        },
        hideModal() {
            this.showModal = false;
        },
        getSubuser() { // 获取提交人
            this.doPost(
        '.getBillSubmitter',
        {billno: this.value.billno, modecode: this.value.billmoduleid},
        (data) => {
            let usercode  = this.getUserCode();
            if (data == usercode) {
                this.isSub = true;
            }
        }
      );
        },
        getTaskID() { // 获取任务ID
            this.istask = false;
            this.doPost(
        '.gettask',
        {billno: this.value.billno},
        (data) => {
            if (data.taskid) {
                this.istask = true;
            }
        }
      );
        },
        getAuditLog() { // 获取审批日志
            this.doPost(
        '.getProcessList',
        {billno: this.value.billno},
        (data) => {
            if (data.procinfo && data.procinfo.proclist) {
                let result = data.procinfo.proclist || [];
                let copylist = [];
                if (data.procinfo.cc && data.procinfo.cc.length > 0) {
                    data.procinfo.cc.forEach(item => {
                        let tmp = {};
                        tmp.active = false;
                        tmp.copyuser = item;
                        tmp.name = item.substr(-2, 2);
                        copylist.push(tmp);
                    });
                }
                result.forEach(item => {
                    item.active = false;
                    item.tasklist.forEach(list => {
                        if (list.username.charAt(list.username.length -1) == '）') list.userName = list.username.substr(-3, 2);
                        else list.userName = list.username.substr(-2, 2);
                  
                    });
                });
                this.auditLog = result;
                this.copyuser = copylist || [];
            }
        }
      );
        },
        formatIcon(state) { // 过滤审批流程状态显示不同icon
            if (state === 'M' || state === 'A') {
                return 'icon-more';
            }
            if (state === 'R' || state === 'N') {
                return 'icon-close';
            }
            if (state === 'Y') {
                return 'icon-success';
            }
            return '';
        },
        showGroupUser(index) {
            this.auditLog[index].active = !this.auditLog[index].active;
        },
        openUser() { // 显示审批人/抄送人
            if (this.isSubmit) this.tabList =[{ label: '抄送人', name: 'USER', active: true }];
            else this.tabList = [{ label: '审批人', name: 'USER', active: true },{ label: '招商组', name: 'USERGROUP', active: false }];
            this.showuser = true;
            this.searchKey = '';
            this.select = [];
            this.getUseList();
        },
        showCopyClick() { // 显示隐藏抄送人
            this.showcopy = !this.showcopy;
        },
        billBack() { // 审批撤回
            this.showopinion = false;
            this.doPost(
        '.billrepeal',
        {billno: this.value.billno},
        (data) => {
            this.alert(data.msg,null,3);
            this.getData();
        }
      );
        },
        openopinion() {
            this.showopinion = true;
            this.opinion = '';
        },
        reject() { // 审批驳回
            this.openopinion();
            this.url = 'billreject';
        },
        pass() { // 审批通过
            this.openopinion();
            this.url = 'billapproval';
        },
        okOpinion() {
            this.submitApprove(this.url);
        },
        cancelOpinion() {
            this.showopinion = false;
        },
        submitApprove(url) {
            this.showopinion = false;
            if (url == 'billaddtask') {
                this.addAuditUser();
                return;
            }
            if (url == 'billreject') {
                if (this.opinion == '') {
                    this.alert('处理意见不能为空',null,1);
                    return;
                }
            }
            this.doPost(
        '.' + url,
        {billno: this.value.billno,comment: this.opinion},
        (data) => {
            this.showuser = false;
            this.alert(data.msg,null,3);
            this.getData();
        }
      );
        },
        billSubmit(cc) {
            let param = {
                billno: this.value.billno
            };
            if (cc && cc.length > 0) param.cc = cc;
            this.doPost(
        '.billsubmit',
        param,
        (data) => {
            this.showModal = true;
            this.showuser = false;
            this.$nextTick(() =>{
                setTimeout(() => {
                    this.alert(data.msg,null,3);
                }, 250);
            });
            this.getData();
            if (this.myConfig.onOk) this.myConfig.onOk();
        }
      );
        },
        addAuditUser() {
            this.showopinion = false;
            let param = {
                addTaskInfo: {
                    list: this.select,
                    type: this.selectType
                },
                billno: this.value.billno,
                userid: this.getUserCode(),
                comment: this.opinion
            };
            this.doPost(
        '.billaddtask',
        param,
        (data) => {
            this.showuser = false;
            this.alert(data.msg,null,3);
            this.getData();
            if (this.myConfig.onOk) this.myConfig.onOk();
        }
      );
        },
        clickTab(name) {
            this.selectType = name;
            this.select = [];
            if (name == 'USER') this.getUseList();
            else if (name == 'USERGROUP') this.getUserGroup();
        },
        change(e) {
            const text = e.target.value;
            this.search(text);
        },
        search(text) {
            if (this.selectType == 'USER') {
                const searchdata = this.userList.filter((item) => {
                    if ((item.firstName && item.firstName.indexOf(text) >= 0) || (item.lastName && item.lastName.indexOf(text) >= 0)) return true;
                });
                this.list = searchdata;
            } else if (this.selectType == 'USERGROUP') {
                const searchdata = this.groupList.filter((item) => {
                    if (item.name && item.name.indexOf(text) >= 0) return true;
                });
                this.list = searchdata;
            }
        },
        canceluser() {
            if (this.isSubmit) this.showModal = false;
            this.showuser = false;
        },
        okuser() {
            if (this.select.length == 0) {
                if (this.isSubmit) this.alert('请选择 抄送人',null,1);
                else this.alert('请选择 审批人',null,1);
                return;
            }
            if (this.isSubmit) {
                this.billSubmit(this.select);
            } else {
                this.openopinion();
                this.url = 'billaddtask';
            }
        },
        getUseList() {
            this.selectType = 'USER';
            if (this.userList && this.userList.length == 0) {
                this.doPost(
              '.getUserList',
              {usercode: ''},
              (data) => {
                  let user = data.userList;
                  user.forEach(item => {
                      if (item.lastName) {
                          item.name = item.lastName.substr(-2, 2);
                      }
                  });
                  this.userList = user;
                  this.search(this.searchKey);
              }
            );
            } else this.search(this.searchKey);
        },
        getUserGroup() {
            this.selectType = 'USERGROUP';
            if (this.groupList && this.groupList.length == 0) {
                this.doPost(
              '.getUserGroupList',
              {groupcode: ''},
              (data) => {
                  let group = data.groupList;
                  this.groupList = group;
                  this.search(this.searchKey);
              }
            );
            } else this.search(this.searchKey);
        },
        doPost(method,postData,SuccessFun) {
            let self = this;
            this.showLoading();
            self.asyncPost(this.myConfig.resources, this.myConfig.classPrefix + method, postData, function(data){
                SuccessFun(data);
                self.hideLoading();
            },function(data) {
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(data,null,2);
                    }, 250);
                });
            },function(data) {
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(data,null,2);
                    }, 250);
                });
            });
        },
    },
    mounted() {
        //this._setCustomHeight(this.clientHeight);
        //this._setCustomWidth(this.clientWidth);
        //this.height = this.clientHeight;
    }
};
</script>

<style>
/* 流程图 */
.audit-log {
  width: 100%;
  overflow: auto;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
}

.bd-space {
  height: 460px;
  overflow-y: auto;
}

.wx-row.color-gray,
.wx-row.color-gray .icon-success,
.wx-row.color-gray .icon-close {
  color: #a6a6ac;
}

.wx-row.color-gray .username,
.wx-row.color-gray .user-item {
  background-color: #a6a6ac;
}

.wx-row .wx-col {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.wx-col .user {
  display: flex;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-direction: row;
}

.wx-col .user .step-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.username,
.user-item {
  position: relative;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  color: #fff;
  margin-right: 17px;
  border-radius: 50%;
  background-color: #3389ff;
}

.username .icon,
.user-item .icon {
  position: absolute;
  bottom: -1px;
  right: 0;
  width: 15px;
  height: 15px;
  line-height: 14px;
  border-radius: 50%;
  background-color: #fff;
}

.user-item .icon {
  width: 15px;
  height: 15px;
}

.username .icon .iconfont {
  font-size: 15px;
}

.user-item .icon .iconfont {
  font-size: 15px;
}

.icon-success {
  color: #56b276;
}

.icon-more {
  color: #fe943e;
}

.icon-close {
  color: #f04141;
}

.step-text .title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.wx-col.add-el {
  margin: 8px 0;
}

.step-text .main {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #82828a;
}

.wx-row .team {
  min-height: 40px;
  padding-left: 36px;
  margin: 5px 0 5px 18px;
  border-left: 4px solid #e4e6e5;
}

.wx-row .team.no-bd {
  border: none;
}

.wx-row .team.full {
  border-left: 4px dashed #e4e6e5;
}

.user .add-text {
  color: #ababab;
  margin: 0 20px;
}

.user .add {
  font-weight: bold;
  min-height: 45px;
  margin: 0 30px;
  color: #ababab;
}

.wx-col .time {
  color: #acacb6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.add-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  color: #3389ff;
  white-space: nowrap;
  max-width: 40px;
  cursor: pointer;
}

.add-wrap .add-btn {
  width: 40px;
  height: 40px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  border: 1px dashed #3389ff;
}

.add-btn .iconfont {
  font-size: 30px;
}

.iconarrow {
  margin-left: 10px;
}

.user-list {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.user-list .user-list-wrap {
  display: flex;
  margin: 10px 0px;
  align-items: center;
}

.user-list-wrap .name {
  color: #808385;
}

.info {
  width: 100%;
  margin-left: 10px;
}

.comment {
  color: #999a9d;
  font-size: 12px;
}

.user-item {
  width: 40px;
  min-width: 40px;
  height: 40px;
  margin-right: 0;
  line-height: 40px;
}

.icon-team,
.icon-bell {
  font-size: 25px;
  margin-top: -1px;
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 57px;
  width: 100%;
}

.btn-group .btn-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50px;
}

.btn-item .iconfont {
  font-size: 24px;
  height: 24px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.opinionfoot {
    display: flex;
    align-items: center;
    justify-content: center;
}

.nodata {
  text-align: center;
  margin-top: 10px
}

/* 添加节点 */
.top{
  width: 100%;
  z-index: 999;
  background-color: #fff;
}

.search-box{
  position: relative;
  /* margin: 0 30rpx; */
  height: 45px;
  padding: 0 40px;
  border-radius: 4px;
  background-color: #ededed;
}

.search-box .input{
  height: 45px;
}

.search-box .iconfont{
  position: absolute;
  padding: 13px;
  top: 0;
  font-size: 18px;
  color: #999a9d;
}

.search-box .icon-search{
  left: 0;
}

.search-box .icon-close{
  right: 0;
}

.wx-tab{
  display: flex;
  text-align: center;
}

.wx-tab .tab-item.active{
  border-bottom: 2px solid #3389FF;
}


.wx-tab .tab-item{
  flex: 1;
  font-size: 16px;
  height: 42px;
  color: #373737;
  line-height: 42px;
  border-bottom: 2px solid #D8D8D8;
}

.content{
  width: 100%;
  bottom: 44px;
}

.scroll-wrap{
  height: 100%;
  background-color: #fff;
}

.checkbox-group {
  height: 390px;
  overflow-y: auto;
}

.checkbox-group .checkbox{
  padding: 5px 0;
  border-bottom: 1px solid #e8eaec;
}

.checkbox .icon{
  width: 35px;
  height: 35px;
  color: #fff;
  line-height: 35px;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
  margin: 0 10px;
  background-color: #3389FF;
}

.checkbox .uname{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.btn-area{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 57px;
}

.checkboxrow {
  width: 100%;
  display: flex;
  align-items: center;
}

.top .ivu-tabs-bar {
  margin-bottom: 0px;
}

.modal .ivu-modal-footer {
  padding: 0px;
}

.submitmodal .modalcontent {
  height: 42px;
  display: flex;
  align-items: center;
}

.submitmodal .helpicon {
  color: #f90;
  font-size: 28px;
  margin: 0 12px;
}

.submitmodal .ivu-modal-footer {
  border-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/layouttemplate/approvalbox.vue